// Traducciones para el modal de creación de reserva
export const translations = {
  es: {
    // Header
    createBooking: 'Crear Nueva Reserva',
    step: 'Paso',
    of: 'de',
    
    // Paso 1: Datos del cliente
    customerData: 'Datos del Cliente',
    fullName: 'Nombre completo',
    email: 'Email',
    phone: 'Teléfono',
    phonePrefixLabel: 'Prefijo',
    phonePrefixPlaceholder: '+34',
    phonePrefixRequired: 'El prefijo telefónico es requerido',
    phonePrefixInvalid: 'Prefijo inválido (hasta 4 dígitos, con o sin +)',
    dni: 'DNI',
    dniPlaceholder: '12345678A',
    requiredFields: 'Campos obligatorios',
    customerNamePlaceholder: 'Nombre del cliente',
    emailPlaceholder: 'email@ejemplo.com',
    phonePlaceholder: '+34 600 000 000',
    dniInvalid: 'DNI inválido (formato: 12345678A)',
    idDocumentLabel: 'Documento de identificación',
    idDocumentPlaceholder: 'DNI, NIE o pasaporte',
    idDocumentRequired: 'El documento de identificación es obligatorio',
    idDocumentInvalid: 'Formato no válido (DNI: 8 dígitos + letra, NIE: X/Y/Z + 7 dígitos + letra, pasaporte: alfanumérico 5-20 caracteres)',
    addressLabel: 'Dirección (facturación)',
    addressPlaceholder: 'Calle, número, código postal, localidad',
    addressRequiredWhenTotal: 'Obligatoria cuando el importe total supera 2.999,99 €',
    
    // Paso 2: Fechas
    datesAndDelivery: 'Fechas y Entrega',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    startDateTime: 'Fecha y hora de inicio',
    endDateTime: 'Fecha y hora de fin',
    deliveryType: 'Tipo de entrega',
    pickup: 'En tienda',
    hotel: 'Entrega en hotel',
    hotelAddress: 'Dirección del hotel',
    hotelAddressPlaceholder: 'Dirección del hotel',
    duration: 'Duración',
    resetDates: 'Restablecer fechas',
    bookingDateRangeFilterLabel: 'Fechas de la reserva',
    bookingDateRangePlaceholder: 'Selecciona el rango de fechas',
    
    // Paso 3: Vehículos
    vehicleSelection: 'Selección de Vehículos',
    allCategories: 'Todas las categorías',
    allSizes: 'Todas las tallas',
    category: 'Categoría',
    vehicleGroup: 'Grupo de vehículos / actividad',
    vehicleGroupBikes: 'Bicicletas',
    vehicleGroupBuggy: 'Buggy',
    vehicleGroupJetSki: 'Jet Ski',
    vehicleGroupParasailing: 'Parasailing',
    loadingVehicles: 'Cargando vehículos disponibles...',
    basePrice: 'Base',
    perDay: '/día',
    discount: 'Descuento 3-5 días',
    totalPrice: 'Precio total',
    seasonalPrice: 'Precio estacional',
    average: 'promedio',
    vatIncluded: 'IVA incluido',
    base: 'Base imponible',
    vat: 'IVA (21%)',
    bookingCreatedSuccess: 'Reserva creada exitosamente',
    success: '¡Éxito!',
    error: 'Error',
    close: 'Cerrar',
    size: 'Talla',
    serialNumber: 'Número de serie',
    selectedVehicles: 'Vehículos seleccionados',
    noVehiclesSelected: 'No hay vehículos seleccionados',
    noVehiclesFound: 'No se encontraron vehículos con los filtros seleccionados',
    clearFilters: 'Limpiar filtros',
    
    // Paso 4: Accesorios
    accessories: 'Accesorios (Opcional)',
    selectVehiclesFirst: 'Primero selecciona vehículos',
    fixedPrice: 'Precio fijo',
    dailyPrice: 'Por día',
    add: 'Añadir',
    remove: 'Quitar',
    
    // Paso 5: Pago
    paymentAndConfirmation: 'Pago y Confirmación',
    paymentMethod: 'Método de pago',
    cash: 'Efectivo',
    card: 'Tarjeta',
    transfer: 'Transferencia',
    bizum: 'Bizum',
    paymentStatus: 'Estado del pago',
    paid: 'Pagado',
    pending: 'Pendiente',
    failed: 'Fallido',
    optional: 'Opcional',
    collaboratorTicket: 'Ticket',
    collaboratorTicketPlaceholder: 'Nº de ticket o referencia',
    selectPaymentMethod: 'Seleccionar método',
    bookingSummary: 'Resumen de la reserva',
    client: 'Cliente',
    start: 'Inicio',
    end: 'Fin',
    vehicles: 'Vehículos',
    total: 'Total',
    priceBreakdown: 'Desglose de precios',
    warningInsuranceNone: 'No has seleccionado ningún seguro para esta reserva.',
    warningInsuranceOnlyOneBike: 'El seguro solo se ha seleccionado para una bicicleta.',
    warningInsurancePartial: 'El seguro solo se ha seleccionado para {count} bicicletas.',
    accessoriesSubtotal: 'Subtotal accesorios',
    insuranceSubtotal: 'Seguros',
    delivery: 'Entrega a domicilio',
    day: 'día',
    days: 'días',
    manualDiscountLabel: 'Descuento manual (%)',
    manualDiscountHint:
      'Opcional. Se aplica sobre el subtotal con IVA (bicicletas, accesorios y suplemento de entrega). El importe descontado queda guardado en la reserva.',
    manualDiscountSummaryLabel: 'Descuento manual',
    manualDiscountPreviewSubtotal: 'Total sin descuento',
    manualDiscountPreviewDiscount: 'Descuento',
    manualDiscountPreviewFinal: 'Total con descuento',
    
    // Botones
    previous: 'Anterior',
    next: 'Siguiente',
    creating: 'Creando...',
    createBookingBtn: 'Crear Reserva',
    cancel: 'Cancelar',
    backToReservations: 'Volver a reservas',
    
    // Validaciones
    nameRequired: 'El nombre es requerido',
    nameMinLength: 'El nombre debe tener al menos 2 caracteres',
    nameMaxLength: 'El nombre no puede superar 100 caracteres',
    nameInvalid: 'Solo se permiten letras y espacios (sin números ni caracteres especiales)',
    emailRequired: 'El email es requerido',
    emailInvalid: 'Introduce un correo electrónico válido',
    phoneRequired: 'El teléfono es requerido',
    startDateRequired: 'La fecha de inicio es requerida',
    startDatePast: 'La fecha de inicio no puede estar en el pasado',
    dateClosed: 'Día cerrado: no se admiten reservas que empiecen o terminen este día',
    startDateAfterEnd: 'La fecha de inicio debe ser anterior a la de fin',
    endDateRequired: 'La fecha de fin es requerida',
    endDateFuture: 'La fecha de fin debe ser en el futuro',
    endDateBeforeStart: 'La fecha de fin debe ser posterior a la de inicio',
    
    // Errores
    errorLoadingVehicles: 'Error al cargar vehículos disponibles',
    errorCreatingBooking: 'Error al crear la reserva',
    
    // Políticas de cancelación
    cancellationPolicyAccept: 'Acepto las',
    cancellationPolicyLink: 'políticas de cancelación',
    cancellationPolicyUrl: 'https://example.com/politicas-cancelacion',
    cancellationPolicyRequired: 'Debes aceptar las políticas de cancelación para continuar'
  },
  
  en: {
    // Header
    createBooking: 'Create New Booking',
    step: 'Step',
    of: 'of',
    
    // Paso 1: Datos del cliente
    customerData: 'Customer Data',
    fullName: 'Full name',
    email: 'Email',
    phone: 'Phone',
    phonePrefixLabel: 'Prefix',
    phonePrefixPlaceholder: '+34',
    phonePrefixRequired: 'Phone prefix is required',
    phonePrefixInvalid: 'Invalid prefix (up to 4 digits, with or without +)',
    dni: 'ID Document',
    dniPlaceholder: '12345678A',
    requiredFields: 'Required fields',
    customerNamePlaceholder: 'Customer name',
    emailPlaceholder: 'email@example.com',
    phonePlaceholder: '+34 600 000 000',
    dniInvalid: 'Invalid ID document (format: 12345678A)',
    idDocumentLabel: 'ID Document',
    idDocumentPlaceholder: 'DNI, NIE or passport',
    idDocumentRequired: 'ID document is required',
    idDocumentInvalid: 'Invalid format (DNI: 8 digits + letter, NIE: X/Y/Z + 7 digits + letter, passport: alphanumeric 5-20 characters)',
    addressLabel: 'Address (billing)',
    addressPlaceholder: 'Street, number, postcode, city',
    addressRequiredWhenTotal: 'Required when total amount exceeds 2,999.99 €',
    
    // Paso 2: Fechas
    datesAndDelivery: 'Dates and Delivery',
    startDate: 'Start date',
    endDate: 'End date',
    startDateTime: 'Start date and time',
    endDateTime: 'End date and time',
    deliveryType: 'Delivery type',
    pickup: 'In store',
    hotel: 'Hotel delivery',
    hotelAddress: 'Hotel address',
    hotelAddressPlaceholder: 'Hotel address',
    duration: 'Duration',
    resetDates: 'Reset dates',
    bookingDateRangeFilterLabel: 'Booking dates',
    bookingDateRangePlaceholder: 'Select date range',
    
    // Paso 3: Vehículos
    vehicleSelection: 'Vehicle Selection',
    allCategories: 'All categories',
    allSizes: 'All sizes',
    category: 'Category',
    vehicleGroup: 'Vehicle / activity group',
    vehicleGroupBikes: 'Bikes',
    vehicleGroupBuggy: 'Buggy',
    vehicleGroupJetSki: 'Jet Ski',
    vehicleGroupParasailing: 'Parasailing',
    loadingVehicles: 'Loading available vehicles...',
    basePrice: 'Base',
    perDay: '/day',
    discount: 'Discount 3-5 days',
    totalPrice: 'Total price',
    seasonalPrice: 'Seasonal price',
    average: 'average',
    vatIncluded: 'VAT included',
    base: 'Tax base',
    vat: 'VAT (21%)',
    bookingCreatedSuccess: 'Booking created successfully',
    success: 'Success!',
    error: 'Error',
    close: 'Close',
    size: 'Size',
    serialNumber: 'Serial number',
    selectedVehicles: 'Selected vehicles',
    noVehiclesSelected: 'No vehicles selected',
    noVehiclesFound: 'No vehicles found with selected filters',
    clearFilters: 'Clear filters',
    
    // Paso 4: Accesorios
    accessories: 'Accessories (Optional)',
    selectVehiclesFirst: 'Select vehicles first',
    fixedPrice: 'Fixed price',
    dailyPrice: 'Per day',
    add: 'Add',
    remove: 'Remove',
    
    // Paso 5: Pago
    paymentAndConfirmation: 'Payment and Confirmation',
    paymentMethod: 'Payment method',
    cash: 'Cash',
    card: 'Card',
    transfer: 'Transfer',
    bizum: 'Bizum',
    paymentStatus: 'Payment status',
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
    optional: 'Optional',
    collaboratorTicket: 'Ticket',
    collaboratorTicketPlaceholder: 'Ticket or reference number',
    selectPaymentMethod: 'Select method',
    bookingSummary: 'Booking summary',
    client: 'Client',
    start: 'Start',
    end: 'End',
    vehicles: 'Vehicles',
    total: 'Total',
    priceBreakdown: 'Price breakdown',
    warningInsuranceNone: 'You have not selected any insurance for this booking.',
    warningInsuranceOnlyOneBike: 'Insurance has only been selected for one bike.',
    warningInsurancePartial: 'Insurance has only been selected for {count} bikes.',
    accessoriesSubtotal: 'Accessories subtotal',
    insuranceSubtotal: 'Insurance',
    delivery: 'Home delivery',
    day: 'day',
    days: 'days',
    manualDiscountLabel: 'Manual discount (%)',
    manualDiscountHint:
      'Optional. Applied to the VAT-inclusive subtotal (bikes, accessories and delivery). The discounted amount is stored on the booking.',
    manualDiscountSummaryLabel: 'Manual discount',
    manualDiscountPreviewSubtotal: 'Total before discount',
    manualDiscountPreviewDiscount: 'Discount',
    manualDiscountPreviewFinal: 'Total after discount',
    
    // Botones
    previous: 'Previous',
    next: 'Next',
    creating: 'Creating...',
    createBookingBtn: 'Create Booking',
    cancel: 'Cancel',
    backToReservations: 'Back to reservations',
    
    // Validaciones
    nameRequired: 'Name is required',
    nameMinLength: 'Name must be at least 2 characters',
    nameMaxLength: 'Name cannot exceed 100 characters',
    nameInvalid: 'Only letters and spaces allowed (no numbers or special characters)',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    phoneRequired: 'Phone is required',
    startDateRequired: 'Start date is required',
    startDatePast: 'Start date cannot be in the past',
    dateClosed: 'Closed day: bookings cannot start or end on this day',
    startDateAfterEnd: 'Start date must be before end date',
    endDateRequired: 'End date is required',
    endDateFuture: 'End date must be in the future',
    endDateBeforeStart: 'End date must be after start date',
    
    // Errores
    errorLoadingVehicles: 'Error loading available vehicles',
    errorCreatingBooking: 'Error creating booking',
    
    // Políticas de cancelación
    cancellationPolicyAccept: 'I accept the',
    cancellationPolicyLink: 'cancellation policy',
    cancellationPolicyUrl: 'https://example.com/cancellation-policy',
    cancellationPolicyRequired: 'You must accept the cancellation policy to continue'
  },
  
  de: {
    // Header
    createBooking: 'Neue Buchung Erstellen',
    step: 'Schritt',
    of: 'von',
    
    // Paso 1: Datos del cliente
    customerData: 'Kundendaten',
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    phone: 'Telefon',
    phonePrefixLabel: 'Vorwahl',
    phonePrefixPlaceholder: '+34',
    phonePrefixRequired: 'Telefonvorwahl ist erforderlich',
    phonePrefixInvalid: 'Ungültige Vorwahl (bis zu 4 Ziffern, mit oder ohne +)',
    dni: 'Ausweisnummer',
    dniPlaceholder: '12345678A',
    requiredFields: 'Pflichtfelder',
    customerNamePlaceholder: 'Kundenname',
    emailPlaceholder: 'email@beispiel.com',
    phonePlaceholder: '+34 600 000 000',
    dniInvalid: 'Ungültige Ausweisnummer (Format: 12345678A)',
    idDocumentLabel: 'Ausweisdokument',
    idDocumentPlaceholder: 'DNI, NIE oder Reisepass',
    idDocumentRequired: 'Ausweisdokument ist erforderlich',
    idDocumentInvalid: 'Ungültiges Format (DNI: 8 Ziffern + Buchstabe, NIE: X/Y/Z + 7 Ziffern + Buchstabe, Reisepass: alphanumerisch 5-20 Zeichen)',
    addressLabel: 'Adresse (Rechnung)',
    addressPlaceholder: 'Straße, Hausnummer, PLZ, Ort',
    addressRequiredWhenTotal: 'Erforderlich bei einem Gesamtbetrag über 2.999,99 €',
    
    // Paso 2: Fechas
    datesAndDelivery: 'Termine und Lieferung',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    startDateTime: 'Startdatum und -zeit',
    endDateTime: 'Enddatum und -zeit',
    deliveryType: 'Lieferart',
    pickup: 'Im Geschäft',
    hotel: 'Hotel-Lieferung',
    hotelAddress: 'Hoteladresse',
    hotelAddressPlaceholder: 'Hoteladresse',
    duration: 'Dauer',
    resetDates: 'Termine zurücksetzen',
    bookingDateRangeFilterLabel: 'Buchungszeitraum',
    bookingDateRangePlaceholder: 'Datumsbereich wählen',
    
    // Paso 3: Vehículos
    vehicleSelection: 'Fahrzeugauswahl',
    allCategories: 'Alle Kategorien',
    allSizes: 'Alle Größen',
    category: 'Kategorie',
    vehicleGroup: 'Fahrzeug- / Aktivitätsgruppe',
    vehicleGroupBikes: 'Fahrräder',
    vehicleGroupBuggy: 'Buggy',
    vehicleGroupJetSki: 'Jet Ski',
    vehicleGroupParasailing: 'Parasailing',
    loadingVehicles: 'Verfügbare Fahrzeuge werden geladen...',
    basePrice: 'Basis',
    perDay: '/Tag',
    discount: 'Rabatt 3-5 Tage',
    totalPrice: 'Gesamtpreis',
    seasonalPrice: 'Saisonpreis',
    average: 'Durchschnitt',
    vatIncluded: 'MwSt. inklusive',
    base: 'Bemessungsgrundlage',
    vat: 'MwSt. (21%)',
    bookingCreatedSuccess: 'Buchung erfolgreich erstellt',
    success: 'Erfolg!',
    error: 'Fehler',
    close: 'Schließen',
    size: 'Größe',
    serialNumber: 'Seriennummer',
    selectedVehicles: 'Ausgewählte Fahrzeuge',
    noVehiclesSelected: 'Keine Fahrzeuge ausgewählt',
    noVehiclesFound: 'Keine Fahrzeuge mit den ausgewählten Filtern gefunden',
    clearFilters: 'Filter zurücksetzen',
    
    // Paso 4: Accesorios
    accessories: 'Zubehör (Optional)',
    selectVehiclesFirst: 'Zuerst Fahrzeuge auswählen',
    fixedPrice: 'Fester Preis',
    dailyPrice: 'Pro Tag',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    
    // Paso 5: Pago
    paymentAndConfirmation: 'Zahlung und Bestätigung',
    paymentMethod: 'Zahlungsmethode',
    cash: 'Bargeld',
    card: 'Karte',
    transfer: 'Überweisung',
    bizum: 'Bizum',
    paymentStatus: 'Zahlungsstatus',
    paid: 'Bezahlt',
    pending: 'Ausstehend',
    failed: 'Fehlgeschlagen',
    optional: 'Optional',
    collaboratorTicket: 'Ticket',
    collaboratorTicketPlaceholder: 'Ticket- oder Referenznummer',
    selectPaymentMethod: 'Methode auswählen',
    bookingSummary: 'Buchungszusammenfassung',
    client: 'Kunde',
    start: 'Start',
    end: 'Ende',
    vehicles: 'Fahrzeuge',
    total: 'Gesamt',
    priceBreakdown: 'Preisaufschlüsselung',
    warningInsuranceNone: 'Sie haben keine Versicherung für diese Buchung ausgewählt.',
    warningInsuranceOnlyOneBike: 'Die Versicherung wurde nur für ein Fahrrad ausgewählt.',
    warningInsurancePartial: 'Die Versicherung wurde nur für {count} Fahrräder ausgewählt.',
    accessoriesSubtotal: 'Zubehör Zwischensumme',
    insuranceSubtotal: 'Versicherung',
    delivery: 'Hauslieferung',
    day: 'Tag',
    days: 'Tage',
    manualDiscountLabel: 'Manueller Rabatt (%)',
    manualDiscountHint:
      'Optional. Wird auf die Zwischensumme inkl. MwSt. (Fahrräder, Zubehör und Lieferzuschlag) angewendet. Der Rabattbetrag wird in der Buchung gespeichert.',
    manualDiscountSummaryLabel: 'Manueller Rabatt',
    manualDiscountPreviewSubtotal: 'Gesamtbetrag ohne Rabatt',
    manualDiscountPreviewDiscount: 'Rabatt',
    manualDiscountPreviewFinal: 'Gesamtbetrag mit Rabatt',
    
    // Botones
    previous: 'Zurück',
    next: 'Weiter',
    creating: 'Wird erstellt...',
    createBookingBtn: 'Buchung Erstellen',
    cancel: 'Abbrechen',
    backToReservations: 'Zurück zu Reservierungen',
    
    // Validaciones
    nameRequired: 'Name ist erforderlich',
    nameMinLength: 'Name muss mindestens 2 Zeichen haben',
    nameMaxLength: 'Name darf maximal 100 Zeichen haben',
    nameInvalid: 'Nur Buchstaben und Leerzeichen (keine Zahlen oder Sonderzeichen)',
    emailRequired: 'E-Mail ist erforderlich',
    emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    phoneRequired: 'Telefon ist erforderlich',
    startDateRequired: 'Startdatum ist erforderlich',
    startDatePast: 'Startdatum darf nicht in der Vergangenheit liegen',
    dateClosed: 'Ruhetag: Buchungen dürfen an diesem Tag weder beginnen noch enden',
    startDateAfterEnd: 'Startdatum muss vor dem Enddatum liegen',
    endDateRequired: 'Enddatum ist erforderlich',
    endDateFuture: 'Enddatum muss in der Zukunft liegen',
    endDateBeforeStart: 'Enddatum muss nach dem Startdatum liegen',
    
    // Errores
    errorLoadingVehicles: 'Fehler beim Laden verfügbarer Fahrzeuge',
    errorCreatingBooking: 'Fehler beim Erstellen der Buchung',
    
    // Políticas de cancelación
    cancellationPolicyAccept: 'Ich akzeptiere die',
    cancellationPolicyLink: 'Stornierungsrichtlinie',
    cancellationPolicyUrl: 'https://example.com/stornierungsrichtlinie',
    cancellationPolicyRequired: 'Sie müssen die Stornierungsrichtlinie akzeptieren, um fortzufahren'
  }
};

// Hook para usar traducciones
export const useTranslations = (language = 'es') => {
  return translations[language] || translations.es;
};

